import ArticleCardSkeleton from '../ArticleCard/SkeletonCard'

interface SkeletonsListProps {
  numberOfArticles: number
}

const SkeletonsList = (props: SkeletonsListProps) => (
  <>
    {Array.from({ length: props.numberOfArticles }).map((_, n) => (
      <ArticleCardSkeleton key={n} />
    ))}
  </>
)

export default SkeletonsList
